import React from 'react';
import { Body1, Body2, Headline } from '../../FontStyles';
import { Link } from 'react-router-dom';
import { FormControl, Typography, Checkbox, FormControlLabel } from '@material-ui/core';
import { Flex, Box } from 'rebass';
import Styled from 'styled-components';
import EditIcon from '@material-ui/icons/Edit';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Button from '../Button';
import { StickyButtonFooter } from './Step';
const Table = Styled(Flex)`
width: 100%;
flex-wrap: wrap;
`;

const TableRow = Styled(Flex)`
width: 100%;
border-top: ${props => (props.first ? props.theme.border : 'none')};
border-bottom: ${props => (props.noBorder ? 'none' : props.theme.border)};
box-sizing: border-box;
justify-content: center;
align-items: center;
padding: ${props => props.theme.space[2]}px;

`;

const TableCell = Styled(Body1)`
padding: ${props => props.theme.space[2]}px;
background-color: ${props => props.theme.colors.background};
width: 100%;
height: 100%;
margin: 0;
text-align: left;


`;

const TherapySettingsContainer = Styled(Flex)`
border: ${props => props.theme.border};
border-radius: 4px;


`;

class FormResponseConfirmationSection extends React.Component {
  render() {
    const values = this.props.values;
    const props = this.props;
    return (
      <Flex width={1}>
        <Box width={0.33} pr={4}>
          <TherapySettingsContainer flexWrap="wrap" width={1}>
            <TableRow noBorder>
              <TableCell>
                <Headline>{`${values.firstName} ${values.lastName}`}</Headline>
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between" noBorder>
              <TableCell width={0.4}>Email</TableCell>
              <TableCell width={0.4} textAlign="right !important">
                {values.email}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between" noBorder>
              <TableCell width={0.4}>Mobile Number</TableCell>
              <TableCell width={0.4} textAlign="right !important">
                {values.phoneNumber}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between" noBorder>
              <TableCell width={0.4}>Type of Account</TableCell>
              <TableCell width={0.4} textAlign="right !important">
                {values.accountType && values.accountType[0].toUpperCase() + values.accountType.substr(1).toLowerCase()}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between" noBorder>
              <TableCell width={0.4}>Birthdate</TableCell>
              <TableCell width={0.4} textAlign="right !important">
                {values.birthday}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between" noBorder>
              <TableCell width={0.4}>Gender</TableCell>
              <TableCell width={0.4} textAlign="right !important">
                {values.gender && values.gender[0].toUpperCase() + values.gender.substr(1).toLowerCase()}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between" noBorder>
              <TableCell width={0.4}>MRN</TableCell>
              <TableCell width={0.4} textAlign="right !important">
                {values.mrn}
              </TableCell>
            </TableRow>
          </TherapySettingsContainer>
        </Box>
        <Box pl={4} width={0.67}>
          <Flex width={1} flexWrap="wrap">
            <TableRow first>
              <TableCell textAlign="left" width={1}>
                <Headline> Confirm Therapy Settings</Headline>
                <Body1>{`Are you sure you want to start this patient on this therapy settings order?`}</Body1>
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>CPT Training Required</TableCell>
              <TableCell width={0.75}>{values.training === 'in-person' ? 'Required' : 'Not required'}</TableCell>
            </TableRow>
            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Correction Range</TableCell>
              <TableCell width={0.75} flexWrap="wrap">
                {values.correctionRange
                  ? values.correctionRange.map((option, index) => (
                      <Flex width={1}>{`${option.time}: ${option.lowerLimit} - ${option.upperLimit} mg/dL`}</Flex>
                    ))
                  : ''}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Suspend Threshold</TableCell>
              <TableCell width={0.75}>{values.suspendThreshold}</TableCell>
            </TableRow>
            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Insulin Model</TableCell>
              <TableCell flexWrap="wrap" width={0.75}>
                {values.insulinModel === 'rapidAdult' && <Flex width={1}>Rapid Acting - Adult</Flex>}
                {values.insulinModel === 'rapidChild' && <Flex width={1}>Rapid Acting - Child</Flex>}
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Delivery Limits</TableCell>
              <TableCell flexWrap="wrap" width={0.75}>
                <Flex width={1}>Max Basal: {values.maxBasal} mg/dL</Flex>
                <Flex width={1}>Max Bolus: {values.maxBolus} mg/dL</Flex>
              </TableCell>
            </TableRow>
            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Basal Rates</TableCell>
              <TableCell width={0.75} flexWrap="wrap">
                {values.basalArray
                  ? values.basalArray.map((option, index) => (
                      <Flex width={1}>{`${option.time}: ${option.val} U/hr`}</Flex>
                    ))
                  : ''}
              </TableCell>
            </TableRow>

            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Insulin Sensitivity Factor</TableCell>
              <TableCell width={0.75} flexWrap="wrap">
                {values.sensitivityArray
                  ? values.sensitivityArray.map((option, index) => (
                      <Flex width={1}>{`${option.time}: ${option.val} mg/dL`}</Flex>
                    ))
                  : ''}
              </TableCell>
            </TableRow>

            <TableRow justifyContent="space-between">
              <TableCell width={0.25}>Insulin to Carbohydrate Ratios</TableCell>
              <TableCell width={0.75} flexWrap="wrap">
                {values.bolusArray
                  ? values.bolusArray.map((option, index) => (
                      <Flex width={1}>{`${option.time}: ${option.val} g/U`}</Flex>
                    ))
                  : ''}
              </TableCell>
            </TableRow>
            <Flex width={1} mt={4} mx={2} mb={100}>
              <FormControl>
                <FormControlLabel
                  name="rxConfirmed"
                  control={
                    <Checkbox
                      color="default"
                      checked={this.props.values.rxConfirmed ? this.props.values.rxConfirmed : false}
                      onChange={this.props.handleChange}
                    />
                  }
                  label={
                    <Typography color="textSecondary">
                      I have confirmed the therapy settings order for this patient
                    </Typography>
                  }
                />
              </FormControl>
            </Flex>

            <StickyButtonFooter justifyContent="center">
              <Flex width={1} px={4} maxWidth={1280} justifyContent="center">
                <Flex width={1} maxWidth={1280} justifyContent="space-between" px={5} alignItems="center">
                  {props.activeSection !== 0 ? (
                    <Button
                      disabled
                      className="large"
                      onClick={() => {
                        props.currentStepNumber > 0
                          ? props.setCurrentStepNumber(props.currentStepNumber - 1)
                          : props.setFieldValue('activeSection', props.values.activeSection - 1);
                      }}
                    >
                      <Flex justifyContent="center" alignItems="center">
                        <Flex pt="2px">
                          <ChevronLeftIcon
                            font-size="inherit"
                            style={{ paddingTop: '2px', fontSize: '24px', maxHeight: '16px' }}
                          />
                        </Flex>
                        {`Previous step`}
                      </Flex>
                    </Button>
                  ) : (
                    <Flex width={0.5} />
                  )}
                  {props.values.rxConfirmed ? (
                    <Button
                      disabled
                      className="large"
                      onClick={() => {
                        props.updateData([
                          ...props.data,
                          {
                            'follower Name': `${values['firstName']} ${values['lastName']}`,
                            MRN: `${values['mrn'] ? values['mrn'] : 'N/A'}`,
                            status: 'Prescription sent',
                            'Avg glucose': '-',
                            'time in range': '-',
                            rxComplete: 'true',
                            timeSubmitted: `${values['timeSubmitted'].getUTCMonth() + 1}/${values[
                              'timeSubmitted'
                            ].getUTCDate()}/${values['timeSubmitted'].getUTCFullYear()}`,
                            allSettings: values
                          }
                        ]);
                        props.setFieldValue('activeSection', 5);
                      }}
                    >
                      Send prescription
                    </Button>
                  ) : (
                    <Button disabled className="greyed large">
                      Send prescription
                    </Button>
                  )}
                </Flex>
              </Flex>
            </StickyButtonFooter>
          </Flex>
        </Box>
      </Flex>
    );
  }
}

export default FormResponseConfirmationSection;
